export const UnauthorizedAlpacaCode: number = 40110000
